import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const { user, loading, initialized } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (initialized && !loading && !user) {
      navigate('/login', { replace: true, state: { from: location.pathname } });
    }
  }, [user, loading, initialized, navigate, location]);

  if (loading || !initialized) {
    return (
      <div className="min-h-screen bg-background-950 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="relative w-12 h-12 flex items-center justify-center">
            <div className="absolute inset-0 rounded-lg bg-accent-500/20 animate-pulse" />
            <i className="ri-loader-4-line text-2xl text-accent-400 animate-spin relative z-10" />
          </div>
          <p className="text-sm text-foreground-400 font-mono">AUTHENTICATING...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return <>{children}</>;
}